import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';

export interface OptionDialogItens{
    key:string;
    value:string;
}

@Component({
    selector: 'app-option-dialog',
    templateUrl: './option-dialog.component.html',
    styleUrls: ['./option-dialog.component.scss'],
    standalone: false
})
export class OptionDialogComponent implements OnInit {

  options:BehaviorSubject<OptionDialogItens[]> = new BehaviorSubject<OptionDialogItens[]>([]);

  tabs = new UntypedFormControl(null, [
    Validators.required
  ]);
  title: any;
  items: OptionDialogItens[] = [];
  
  constructor(@Inject(MAT_DIALOG_DATA) public data, public dialogRef:MatDialogRef<any>) { }


  ngOnInit(): void {
    this.title = this.data.title;
    this.items = this.data.items;
    this.options.next(this.items);
  }

  ngAfterContentInit(): void {
    
  }

  salvar(){
    this.dialogRef.close(this.tabs.value)
  }

}
